import { render } from "./BlockIcon.vue?vue&type=template&id=a18ed052"
import script from "./BlockIcon.vue?vue&type=script&lang=js"
export * from "./BlockIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__